<template>
  <v-list-tile>
    <!-- The text with the info showing the setting value -->
    <v-list-tile-content>
      <v-list-tile-title>
        <slot name="info" />
      </v-list-tile-title>
    </v-list-tile-content>
    <!-- The edit icon to open a dialog to edit it -->
    <v-list-tile-action>
      <v-dialog v-model="$data._showingDialog" lazy :width="dialogWidth">
        <!-- The icon as activator of the dialog -->
        <template #activator="{ on }">
          <v-btn v-on="on" icon>
            <v-icon color="blue-grey">edit</v-icon>
          </v-btn>
        </template>
        <!-- The slot to add your custom component to edit the setting value -->
        <slot name="input" />
      </v-dialog>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
/**
 * An abstract component with a "info" slot to populate with a simple text indicating the
 * setting's value and an "input" slot to provide the component that handles the logic
 * to change the value.
 *
 * You can control the visibility of the dialog that contains the input component with the
 * `.sync` modifier over the `showingDialog` property.
 */

export default {
  props: {
    dialogWidth: {
      type: Number,
      default: 500
    },
    showingDialog: {
      type: Boolean,
    }
  },
  data: () => ({
    _showingDialog: false
  }),
  watch: {
    "$data._showingDialog"() {
      this.$emit("update:showingDialog", this.$data._showingDialog);
    },
    showingDialog() {
      this.$data._showingDialog = this.showingDialog;
    }
  }
};
</script>
